<template>
    <div class="container ">
        <div class="row">
            <div id="orcidWidget" class="small col-12 col-md-6 mx-auto my-auto">
                <a id="orcidAuthButton" :href="returnUrl">
                    <img src="https://orcid.org/sites/default/files/images/orcid_24x24.png" />
                    Authenticate your ORCID iD
                </a>
            </div>
        </div>
    </div>

</template>

<script>
/* eslint-disable */


const sandboxIssuer = "https://sandbox.orcid.org";
const sandboxUrl = "https://sandbox.orcid.org/oauth/authorize";
const sandboxKey = { "kty": "RSA", "e": "AQAB", "use": "sig", "kid": "sandbox-orcid-org-3hpgosl3b6lapenh1ewsgdob3fawepoj", "n": "pl-jp-kTAGf6BZUrWIYUJTvqqMVd4iAnoLS6vve-KNV0q8TxKvMre7oi9IulDcqTuJ1alHrZAIVlgrgFn88MKirZuTqHG6LCtEsr7qGD9XyVcz64oXrb9vx4FO9tLNQxvdnIWCIwyPAYWtPMHMSSD5oEVUtVL_5IaxfCJvU-FchdHiwfxvXMWmA-i3mcEEe9zggag2vUPPIqUwbPVUFNj2hE7UsZbasuIToEMFRZqSB6juc9zv6PEUueQ5hAJCEylTkzMwyBMibrt04TmtZk2w9DfKJR91555s2ZMstX4G_su1_FqQ6p9vgcuLQ6tCtrW77tta-Rw7McF_tyPmvnhQ" };
const prodIssuer = "https://orcid.org";
const prodUrl = "https://orcid.org/oauth/authorize";
const prodKey = { "kty": "RSA", "e": "AQAB", "use": "sig", "kid": "production-orcid-org-7hdmdswarosg3gjujo8agwtazgkp1ojs", "n": "jxTIntA7YvdfnYkLSN4wk__E2zf_wbb0SV_HLHFvh6a9ENVRD1_rHK0EijlBzikb-1rgDQihJETcgBLsMoZVQqGj8fDUUuxnVHsuGav_bf41PA7E_58HXKPrB2C0cON41f7K3o9TStKpVJOSXBrRWURmNQ64qnSSryn1nCxMzXpaw7VUo409ohybbvN6ngxVy4QR2NCC7Fr0QVdtapxD7zdlwx6lEwGemuqs_oG5oDtrRuRgeOHmRps2R6gG5oc-JqVMrVRv6F9h4ja3UgxCDBQjOVT1BFPWmMHnHCsVYLqbbXkZUfvP2sO1dJiYd_zrQhi-FtNth9qrLLv3gkgtwQ" };


export default {
    props: ["clientId", "env", "redirectUri"],
    data() {
        return {
            returnUrl: "",
            issuer: '',
            authUrl: '',
            // redirectUri: 'https://fdi-nlp.ucsd.edu/callback',
            isSuccess: false,
        }
    },

    methods: {
        buildReturnUrl(nonce) {
            let url = this.authUrl + "?response_type=token&redirect_uri=" + this.redirectUri + "&client_id=" + this.clientId + "&scope=openid";
            if (nonce)
                url += "&nonce=" + nonce;
            return url;
        },

    },
    mounted() {
        // console.log("env=" + this.env)
        // console.log("clientId=", this.clientId)
        if (this.env === 'production') {
            this.issuer = prodIssuer;
            this.authUrl = prodUrl;
            this.key = prodKey;
        } else {
            this.issuer = sandboxIssuer;
            this.authUrl = sandboxUrl;
            this.key = sandboxKey;
        }

        this.returnUrl = this.buildReturnUrl()
        // TEST
        //this.returnUrl = "http://localhost:8081"
    }
}
</script>
<style scoped>
#orcidWidget {
    color: #494A4C;
    font-family: Helvetica, Arial, sans-serif;
}

#orcidAuthButton {
    display: block;
    position: relative;
    width: 80%;
    border: 1px solid #d3d3d3;
    border-radius: 5px;
    background-color: #fff;
    margin: 1em auto;
    padding: .6em;
    cursor: pointer;
    color: #494A4C;
    text-decoration: none;
}

#orcidWidget.large {
    width: 400px;
    font-size: 18px;
    line-height: 22px;
}

#orcidWidget.large img {
    width: 20px;
    height: 20px;
    margin-right: 4px;
    vertical-align: top;
}

#orcidWidget.small {
    width: 300px;
    font-size: 14px;
    line-height: 16px;
}

#orcidWidget.small img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    vertical-align: top;
}

#orcidAuthButton:hover {
    background-color: #e0e0e0;
    border: solid 1px #d3d3d3;
}

</style>
